module.exports = __webpack_public_path__ + "img/thumb-010-02.ab288ca8.png";